import { Branding, useStateManager } from "@bcm-dev/bcms-vite";
import { CustomAccountSelect } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import { Account } from "model";
import React from 'react';
import "./styles.css";

/**
 * @function MultiWireTable
 * @return {React.Component}
 * @exported true
 * @description The table that shows the multi wires
 */

export default function MultiWireTable(props) {
  const { onChange } = useStateManager();
  const wire = props.wire ?? {};
  const payeeType = wire.payee.payeeType.charAt(0).toUpperCase() + wire.payee.payeeType.slice(1);

  return(
    <TableView className="multi-wire-table">
      {/* colgroup is needed for table layout */}
      {/*<colgroup>
        <col span="1" />
        <col span="1" />
        <col span="1" />
        <col span="1" />
        <col span="1" />
      </colgroup>*/}
      <thead className="table-column-container">
        <tr>
          <th className="text-left table-column-view" colSpan="2">Payee Nickname</th>
          <th className="text-left table-column-view">Payee Name</th>
          <th className="text-left table-column-view" colSpan="2">
            <div className="flex-container flex-horizontal align-center">
              <div className="set-width notify-payee-label"></div>
              <div className="flex-width">Wire Date</div>
            </div>
          </th>
        </tr>
      </thead>

      <TableBody>
        <tr className="table-item-container">
          <td className="table-item-view"><b>{ wire.payee.nickname }</b></td>
          <td className="table-item-view"></td>
          <td className="table-item-view"><b>{ wire.payee.name }</b></td>
          <td className="table-item-view" colspan="2">
            <div className="flex-container flex-horizontal align-center">
              <div className="set-width notify-payee-value">
                
              </div>
              <div className="flex-width">
                <DateSelect value={ wire.date } onChange={ onChange("date", wire) } />
              </div>
            </div>
           
            
          </td>
        </tr>
        <tr className="table-item-container">
          <td className="table-item-view payee-type" colSpan="2">
            <div className="flex-container flex-horizontal align-center">
              <p className="set-width left-inline-label">Type:</p>
              <b className="set-width">{ payeeType }</b>
            </div>
          </td>
          <td className="table-item-view"></td>
          <td className="table-item-view"></td>
          <td className="table-item-view"></td>
        </tr>
        <tr className="table-item-container">
          <td className="table-item-view account" colSpan="2">
            <div className="flex-container flex-horizontal align-center">
              <p className="set-width left-inline-label">Account:</p>
              <CustomAccountSelect className="set-width" value={ Account.initByType(wire.fundingAccount.id) } accounts={ Account.initAllAsset() } onChange={ onChange("fundingAccount", wire) } />
            </div>
          </td>
          
          <td className="table-item-view amount">
            <div className="flex-container flex-horizontal align-center">
              <p className="left-inline-label set-width">Amount:</p>
              <UIAmountInput className="amount-field" value={ wire.amount.amount === "" ? undefined : wire.amount.format({style:"decimal"}) } onBlur={ onChange("amount", wire) } />
            </div>
          </td>
          <td className="table-item-view">
            <div className="flex-container flex-horizontal align-center">
              <div className="flex-container flex-horizontal align-center left-inline-label-v2">
                <p className="left-inline-label set-width">Last:</p>
                <b className="flex-width">N/A</b>
              </div>
              <div className="flex-container flex-horizontal align-center">
                <p className="left-inline-label set-width">Scheduled:</p>
                <b className="flex-width">N/A</b>
              </div>
            </div>
            
          </td>
          <td className="table-item-view">
            
          </td>
        </tr>
        <Branding id="memo_abi22" value="true">
          <tr className="table-item-container">
            <td className="table-item-view"><p>Memo:</p></td>
            <td className="table-item-view" colSpan="2">
              <UITextInput value={ wire.memo } onBlur={ onChange("memo", wire) } />
            </td>
            <td className="table-item-view"></td>
            <td className="table-item-view"></td>
          </tr>
        </Branding>
        <Branding id="beneficiaryref_abi22" value="true">
          <tr className="table-item-container">
            <td className="table-item-view"><p>Beneficiary Reference:</p></td>
            <td className="table-item-view">
              <UITextInput value={ wire.beneficiaryReference } onBlur={ onChange("beneficiaryReference", wire) } />
            </td>
            <td className="table-item-view"></td>
            <td className="table-item-view"></td>
            <td className="table-item-view"></td>
          </tr>
        </Branding>

        <Branding id="messagetobeneficiary_abi22" value="true">
          <tr className="table-item-container">
            <td className="table-item-view"><p>Message to Beneficiary:</p></td>
            <td className="table-item-view">
              <UITextInput value={ wire.messageToBeneficiary1 } onBlur={ onChange("messageToBeneficiary1", wire) } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ wire.messageToBeneficiary2 } onBlur={ onChange("messageToBeneficiary2", wire) } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ wire.messageToBeneficiary3 } onBlur={ onChange("messageToBeneficiary3", wire) } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ wire.messageToBeneficiary4 } onBlur={ onChange("messageToBeneficiary4", wire) } />
            </td>
          </tr>
        </Branding>

      </TableBody>
    </TableView>
  );
}